module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate19.28ff277.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate19.png
// module id = 754
// module chunks = 0